import React from "react";
import { COUNTRIES, FLAGSHIP_BRANDS } from "../../data/kdm";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F0F10] text-[#E5E5E5] pt-24 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/u0h0fq87_KDM%20logo.png"
              alt="KDM Group"
              className="h-16 w-auto bg-white p-1.5 rounded-sm"
            />
            <span className="overline !text-gold">Group</span>
          </div>
          <p className="font-serif italic text-2xl mt-6 text-white/90">
            Building tomorrow, together.
          </p>
          <p className="text-sm text-white/60 mt-6 max-w-md leading-relaxed">
            A multi-national conglomerate operating across hospitality, real estate, trade,
            manufacturing, technology and lifestyle — anchored by 15+ years of trusted
            performance.
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="overline">Footprint</p>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            {COUNTRIES.map((c) => (
              <li key={c.code} className="flex items-center justify-between">
                <span>{c.name}</span>
                <span className="text-white/40 text-xs tracking-[0.2em]">{c.code}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="overline">Group Brands</p>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3 text-xs text-white/65 tracking-[0.16em]">
            {FLAGSHIP_BRANDS.map((b) =>
              b.href ? (
                <li key={b.label}>
                  <a
                    href={b.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-brand-${b.label.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                    className="hover:text-gold transition-colors duration-300"
                  >
                    {b.label} ↗
                  </a>
                </li>
              ) : (
                <li key={b.label}>{b.label}</li>
              )
            )}
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/45 tracking-[0.18em] uppercase">
        <p>© {new Date().getFullYear()} KDM Group. All rights reserved.</p>
        <p>Trusted by generations · Sustainable growth</p>
      </div>
    </footer>
  );
}
